/**
 * Iter209cl — Nome visualizzato del proprietario/cliente.
 *
 * Centralizza la logica "privato → nome+cognome, azienda → ragione sociale".
 * Applicata ovunque nell'app si mostri il nome del cliente/proprietario
 * di un immobile, per evitare divergenze.
 */
export function ownerDisplayName(prop) {
  if (!prop) return "";
  if (prop.owner_type === "azienda") {
    return (prop.owner_company_name || "").trim();
  }
  const fn = (prop.owner_first_name || "").trim();
  const ln = (prop.owner_last_name || "").trim();
  return `${fn} ${ln}`.trim();
}

export default ownerDisplayName;
